import React from "react"
import { useNavigate,Link } from "react-router-dom";
import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebase";
const Login=()=>{
    const [err,seterr]=useState(false);
    const navigate=useNavigate();

    const handlesub=async(e)=>{
        e.preventDefault()
        
        const email=e.target[0].value;
        const password=e.target[1].value;
        
        try{
            await signInWithEmailAndPassword(auth, email, password);
            navigate("/");
        }catch(error){
            console.log(error);
            alert(error);
        }
}
    return(
        <div className="formContainer">
            <div className="formWrapper">
                <span className="logo">Quick Chat</span>
                <span className="title">Login</span>
                <form onSubmit={handlesub}>
                    
                    <input type="text" placeholder="Email" />
                    <input type="text" placeholder="Password" />
                    
                    <button type="submit">Sign in</button>
                </form>
                <p>Don't have an account? <Link to={"/register"}>Register</Link></p>
            </div>
        </div>
    )
}

export default Login